import { createStyles, colors } from '@material-ui/core';
import { fade } from '@material-ui/core/styles';

var getToolbarTextColor = function getToolbarTextColor(theme) {
  return theme.palette.type === 'light' ? theme.palette.primary.contrastText : theme.palette.getContrastText(theme.palette.background.default);
};

export default (function (theme) {
  return createStyles({
    fieldContainer: {
      display: 'block',
      position: 'relative'
    },
    fieldLoaderContainer: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0
    },
    fieldLoader: {
      position: 'absolute',
      right: theme.spacing(1),
      top: '50%',
      marginTop: -12,
      color: 'rgba(0,0,0,0.23)'
    },
    slimFieldLoader: {
      marginTop: -8
    },
    textFieldControl: {
      margin: 0
    },
    labelAsterisk: {
      fontWeight: 500,
      color: '#ff2525'
    },
    baseOutlinedInputRoot: {
      padding: 0
    },
    baseOutlinedInput: {
      padding: theme.spacing(1.2, 2)
    },
    baseOutlinedLabel: {
      transform: 'translate(14px, 12px) scale(1)'
    },
    baseCheckControl: {
      height: 34
    },
    errorColor: {
      color: theme.palette.error.main
    },
    errorBackgroundColor: {
      backgroundColor: theme.palette.error.main
    },
    slimOutlinedInputRoot: {
      padding: 0,
      height: 26
    },
    slimOutlinedInput: {
      padding: theme.spacing(0.4, 1),
      fontSize: 12,
      height: 'auto'
    },
    slimOutlinedLabel: {
      transform: 'translate(8px, 7px) scale(1)',
      fontSize: 12
    },
    disabledInput: {
      background: '#eee',
      cursor: 'default',
      userSelect: 'none'
    },
    modalFormWrapper: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    },
    modalGridWrapper: {
      paddingTop: theme.spacing(2),
      maxHeight: '60vh',
      overflow: 'auto',
      display: 'flex'
    },
    modalGridWrapperSlim: {
      paddingTop: theme.spacing(0.5)
    },
    clearButton: {
      position: 'absolute',
      right: 0,
      top: 19,
      transform: 'translateY(-50%)',
      zIndex: 2
    },
    dateClearButton: {
      right: 36
    },
    clearButtonSlim: {
      top: 13
    },
    dateClearButtonSlim: {
      top: 13,
      right: 24
    },
    label: {
      whiteSpace: 'nowrap'
    },
    clippedLabel: {
      overflow: 'hidden',
      maxWidth: 'calc(100% - 28px)',
      display: 'block',
      textOverflow: 'ellipsis'
    },
    clippedLabelWithAdornment: {
      maxWidth: 'calc(100% - 60px)'
    },
    shrinkLabel: {
      maxWidth: 'calc(125% + 14px)'
    },
    notchedOutline: {
      minWidth: 0
    },
    autocompleteRoot: {
      flexGrow: 1
    },
    autocompleteControl: {
      marginTop: 0,
      marginBottom: 0
    },
    autocompleteInput: {
      display: 'flex',
      padding: 0,
      paddingLeft: theme.spacing(1),
      height: 'auto'
    },
    autocompleteValueContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      flex: 1,
      alignItems: 'center',
      overflow: 'hidden'
    },
    autocompleteValueContainerSlim: {
      minHeight: 26,
      fontSize: 12
    },
    autocompleteChip: {
      margin: theme.spacing(0.25)
    },
    autocompleteChipFocused: {
      backgroundColor: theme.palette.grey[300]
    },
    autocompleteChipSlim: {
      height: 20,
      fontSize: 12,
      borderRadius: 10
    },
    autocompleteChipLabelSlim: {
      paddingLeft: 6,
      paddingRight: 6
    },
    autocompleteChipDeleteIconSlim: {
      marginRight: -2
    },
    autocompleteNoOptionsMessage: {
      padding: theme.spacing(1, 2)
    },
    autocompleteNoOptionsMessageSlim: {
      padding: theme.spacing(0.25, 1)
    },
    autocompleteSingleValue: {
      fontSize: 16,
      whiteSpace: 'nowrap',
      maxWidth: 'calc(100% - 6px)',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    autocompleteSingleValueSlim: {
      fontSize: 12
    },
    autocompletePlaceholder: {
      position: 'absolute',
      left: 2,
      bottom: 6,
      fontSize: 16,
      paddingLeft: theme.spacing(1),
      fontStyle: 'italic'
    },
    autocompletePlaceholderSlim: {
      fontSize: 14,
      bottom: 4
    },
    autocompletePaper: {
      position: 'absolute',
      zIndex: 1300,
      marginTop: theme.spacing(1 / 8),
      left: 0,
      right: 0
    },
    autocompletePaperTop: {
      bottom: 'calc(100% + 8px)',
      marginTop: 0
    },
    autocompletePaperTopSlim: {
      bottom: 'calc(100% + 4px)'
    },
    autocompleteItem: {
      whiteSpace: 'normal'
    },
    autocompleteItemSlim: {
      fontSize: 12,
      padding: theme.spacing(3 / 8, 6 / 8)
    },
    autocompleteSelectedItem: {
      background: 'rgba(0, 0, 0, 0.28)'
    },
    outlinedInputMultiSelect: {
      padding: theme.spacing(0.125, 1),
      minHeight: 36
    },
    slimOutlinedInputMultiSelect: {
      padding: theme.spacing(0.25, 1),
      minHeight: 26
    },
    selectChips: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    selectChip: {
      margin: 2
    },
    selectChipSlim: {
      height: 22
    },
    pickerWrapper: {
      padding: 0,
      '@global': {
        '.MuiPickersCalendar-transitionContainer': {
          minHeight: 240
        }
      }
    },
    pickerBtns: {
      justifyContent: 'center'
    },
    picker: {
      position: 'relative',
      overflow: 'hidden'
    },
    day: {
      width: 36,
      height: 36,
      fontSize: theme.typography.caption.fontSize,
      margin: '2px',
      color: 'inherit'
    },
    highlightNonCurrentMonthDay: {
      color: '#676767'
    },
    highlight: {
      background: theme.palette.primary.light,
      color: theme.palette.common.white,
      borderRadius: 0
    },
    oneDayHighlight: {
      background: theme.palette.primary.main + ' !important',
      color: theme.palette.common.white + ' !important',
      borderRadius: '50%'
    },
    firstHighlight: {
      background: theme.palette.primary.light,
      color: theme.palette.common.white,
      borderTopLeftRadius: '50%',
      borderBottomLeftRadius: '50%'
    },
    endHighlight: {
      background: theme.palette.primary.light,
      color: theme.palette.common.white,
      borderTopRightRadius: '50%',
      borderBottomRightRadius: '50%'
    },
    findFieldButton: {
      display: 'block',
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      background: 'none',
      cursor: 'pointer'
    },
    findFieldButtonDisabled: {
      cursor: 'default'
    },
    datePickerToolbar: {
      alignItems: 'center',
      justifyContent: 'center',
      height: 48,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.background.default
    },
    datePickerToolbarLandscape: {
      padding: 16
    },
    datePickerToolbarDateLandscape: {
      marginRight: 16
    },
    datePickerToolbarTxt: {
      color: fade(getToolbarTextColor(theme), 0.54)
    },
    datePickerToolbarBtnSelected: {
      color: getToolbarTextColor(theme)
    },
    datePickerToolbarButtonsDate: {
      display: 'flex',
      alignItems: 'baseline',
      width: '100%',
      justifyContent: 'center'
    },
    datePickerToolbarButtonsDateTxt: {
      color: fade(getToolbarTextColor(theme), 0.54),
      fontSize: 18
    },
    datePickerToolbarButtonsDateTxtSelected: {
      color: getToolbarTextColor(theme)
    },
    datePickerToolbarButtonsDateBtn: {
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      minWidth: 0
    },
    calendars: {
      display: 'flex'
    },
    uploadContainer: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      alignItems: 'flex-start',
      textAlign: 'left',
      overflow: 'hidden'
    },
    uploadContent: {
      display: 'flex',
      flexDirection: 'row',
      boxSizing: 'border-box',
      width: '100%'
    },
    uploadFiles: {
      paddingLeft: 32,
      alignItems: 'flex-start',
      justifyItems: 'flex-start',
      flex: 1,
      overflowY: 'auto',
      minWidth: 300,
      maxWidth: 800
    },
    uploadActions: {
      display: 'flex',
      flex: 1,
      width: '100%',
      justifyContent: 'flex-end',
      flexDirection: 'row',
      marginTop: 32
    },
    uploadRowActions: {
      marginLeft: 8,
      display: 'flex',
      alignItems: 'center'
    },
    newFilesActions: {
      display: 'flex',
      flex: 1,
      width: '100%',
      justifyContent: 'flex-end',
      flexDirection: 'row',
      marginTop: 16
    },
    uploadFilenameWrapper: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    uploadFilename: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'relative',
      '& span': {
        fontSize: 16,
        color: '#555'
      }
    },
    uploadRow: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'space-between',
      boxSizing: 'border-box',
      marginBottom: 8
    },
    uploadSuccessIcon: {
      color: colors.green[600],
      position: 'absolute',
      left: -24
    },
    uploadErrorText: {
      color: colors.red[600],
      fontSize: 10
    },
    dropZone: {
      height: 200,
      width: 200,
      backgroundColor: '#fff',
      border: '2px dashed rgb(187, 186, 186)',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      fontSize: 16,
      position: 'relative'
    },
    dropZoneHighlighted: {
      backgroundColor: 'rgb(188, 185, 236)'
    },
    dropZoneIcon: {
      opacity: 0.3,
      height: 100,
      width: 100
    },
    dropZonePlaceholder: {
      textAlign: 'center',
      fontStyle: 'italic',
      fontSize: 11,
      maxWidth: '80%',
      marginTop: 35,
      marginBottom: -10,
      opacity: 0.85,
      userSelect: 'none'
    },
    fileInput: {
      display: 'none'
    },
    circularProgressWrapper: {
      width: 26,
      height: 26,
      position: 'relative',
      overflow: 'hidden'
    },
    circularProgress: {
      position: 'absolute',
      marginTop: -9,
      marginLeft: -9,
      top: '50%',
      left: '50%'
    },
    itemsPopupMenu: {
      zIndex: 100,
      width: '100%',
      marginTop: 8,
      marginBottom: 8,
      overflowY: 'auto',
      maxHeight: 278,
      '& li': {
        whiteSpace: 'initial',
        fontSize: 14
      }
    },
    checkGroupLabel: {
      color: 'inherit',
      '&$checkGroupLabelFocused': {
        color: 'inherit'
      }
    },
    checkGroupLabelFocused: {},
    checkGroupCheckbox: {
      padding: 6,
      marginLeft: -4
    },
    slimCheckGroupCheckbox: {
      padding: 3,
      marginLeft: -5
    },
    checkGroup: {
      marginTop: 8
    },
    slimCheckGroup: {
      marginTop: 0
    },
    checkGroupControlLabel: {
      marginLeft: 0
    },
    checkGroupControl: {
      padding: 6
    },
    checkGroupColumnControlLabel: {
      width: '100%',
      wordBreak: 'break-all',
      marginRight: 0
    },
    checkLabel: {
      fontSize: 14
    },
    slimCheckRoot: {
      marginLeft: -5
    },
    slimCheckLabel: {
      fontSize: 12
    },
    slimCheckControl: {
      height: 26,
      width: 26,
      padding: theme.spacing(0.625)
    },
    timeSelector: {
      marginBottom: -305,
      height: 305,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    timeSelectorItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    timeSelectorSeparator: {
      fontWeight: 500,
      fontSize: 20,
      padding: theme.spacing(0, 1)
    },
    slimSwitchRoot: {
      width: 46,
      height: 26,
      padding: '10px 12px'
    },
    slimSwitchThumb: {
      width: 16,
      height: 16
    },
    slimHelperText: {
      marginTop: theme.spacing(0.25),
      marginLeft: 0,
      fontSize: 10
    }
  });
});